import React, { useEffect, useState, useMemo, Fragment } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Accordion, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { IoIosArrowDropdownCircle, IoMdPlay } from "react-icons/io";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import { fetchhorsehistory, getHorseHistory } from "../../redux/getReducer/getHorseHistory";
import { fetchHorsemodalstats } from "../../redux/getReducer/getHorseModalstats";
import Moment from "react-moment";
import PleaseWait from "../Reuseable/PleaseWait";
import VideoFrame from "../Modal/VideoFrame";
import JockeyDetail from "../Modal/JockeyModal";
import HorseModal from "../Modal/HorseModal";
import RaceModal from "../Modal/RaceModal";
import ScrollContainer from "react-indiana-drag-scroll";
import Lottie from "lottie-react";
import Animate from "../../assets/loader.json";
import { truncateRaceType, toTitleCase } from "../../service/stringUtils";

// Isolated Style Import
// import "./StatsTabNew.css"; 

const Stats = ({ id }) => {
  const { data: horsehistory, statusdata } = useSelector((state) => state.horsehistory);
  const { data: horsemodalstats } = useSelector((state) => state.horsemodalstats);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");

  const [compIndex, setCompIndex] = useState(null);
  const [ShowJockey, setShowJockey] = useState(false);
  const [modaldatasJockey, setmodaldatasJockey] = useState();
  const handleJockeyCloses = () => setShowJockey(false);
  const handleShowJockey = (data) => { const id = data?._id || data; if (id) navigate("/jockey-detail?" + id); };

  const [showRace, setShowRace] = useState(false);
  const [modaldataRace, setmodaldataRace] = useState();
  const handleCloseRace = () => setShowRace(false);
  const handleShowRace = (data) => { const id = data?._id || data; if (id) navigate("/race-detail?" + id); };

  const [show, setShow] = useState(false);
  const [modaldata, setmodaldata] = useState();
  const handleClose = () => setShow(false);
  const handleShow = async (data) => { setmodaldata(data); await setShow(true); };

  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();
  const handleCloses = () => setShows(false);
  const handleShows = async (data) => { setmodaldatas(data); await setShows(true); };

  useEffect(() => {
    const finalId = id?._id || id;
    dispatch(fetchhorsehistory({ year: "", id: finalId }));
    dispatch(fetchHorsemodalstats({ id: finalId }));
  }, [dispatch, id]);

  // Per-year rows come from the API (?year=) and stay local, so the shared
  // horsehistory (all years) used by the Form tab is not replaced.
  const [yearHistory, setYearHistory] = useState({});
  useEffect(() => { setYearHistory({}); }, [id]);

  const handleTrainerRecord = (year, index) => {
    if (compIndex === index) { setCompIndex(null); return; }
    setCompIndex(index);
    const finalId = id?._id || id;
    if (!year) {
      if (!horsehistory || horsehistory.length === 0) {
        dispatch(fetchhorsehistory({ year: "", id: finalId }));
      }
      return;
    }
    if (yearHistory[year]) return;
    getHorseHistory({ id: finalId, year })
      .then((rows) => setYearHistory((prev) => ({ ...prev, [year]: rows })))
      .catch(() => setYearHistory((prev) => ({ ...prev, [year]: [] })));
  };

  function distanceLabel(distance, rank) {
    const d = parseFloat(distance);
    if (d.toFixed(2) > 25) return "Dist";
    if (d.toFixed(2) == 0.05 && rank < 80) return "SHd";
    if (d.toFixed(2) == 0.10 && rank < 80) return "Hd";
    if (d.toFixed(2) == 0.25 && rank < 80) return "Nk";
    if (d.toFixed(2) == 0.01 && rank < 80) return "Ns";
    if (d.toFixed(2) == 0.00 && rank < 80) return rank === 1 ? 0 : "Dh";
    return distance;
  }

  return (
    <div className="horse-stats-responsive-wrapper">
      <div className="new-horse-stats-table-box" style={{ padding: 0, background: 'transparent' }}>
        <div className="table-x-scroll-wrapper">
          {/* --- DIV BASED TABLE HEAD (11 Columns to match CSS Grid) --- */}
          <div className="new-horse-main-thead">
            <div>{t("Year")}</div><div>{t("Runs")}</div><div>{t("Wins")}</div><div>{t("Second")}</div>
            <div>{t("Third")}</div><div>{t("Fourth")}</div><div>{t("Fifth")}</div><div>{t("Earning")}</div>
            <div>{t("Wins")}%</div><div>{t("Place")}%</div><div></div><div></div>
          </div>

          {/* 1. OVERALL STATS ACCORDION */}
          <Accordion className="new-horse-stats-accordion-wrapper" activeKey={compIndex === "overall" ? "0" : ""}>
            <Accordion.Item eventKey="0" className="new-horse-acc-item">
              <Accordion.Header className="new-horse-acc-header-custom" onClick={() => handleTrainerRecord("", "overall")}>
                <div className="new-horse-acc-header-grid">
                  <div className="new-horse-bold-text">OverAll</div>
                  <div>{horsemodalstats.OverAll?.Runs}</div><div>{horsemodalstats.OverAll?.wins}</div>
                  <div>{horsemodalstats.OverAll?.second}</div><div>{horsemodalstats.OverAll?.third}</div>
                  <div>{horsemodalstats.OverAll?.fourth}</div><div>{horsemodalstats.OverAll?.fifth}</div>
                  <div className="new-horse-bold-text">{t("AED")} {Number(horsemodalstats.OverAll?.earning || 0).toLocaleString()}</div>
                  <div>{Number(horsemodalstats.OverAll?.winspercentage || 0).toFixed(2)}</div>
                  <div>{Number(horsemodalstats.OverAll?.placespercentage || 0).toFixed(2)}</div>
                  <div></div>
                  <div style={{ textAlign: 'right' }}>
                    {compIndex === "overall" ? <MdKeyboardArrowDown className="new-horse-acc-arrow-icon" /> : <MdKeyboardArrowRight className="new-horse-acc-arrow-icon" />}
                  </div>
                </div>
              </Accordion.Header>
              <Accordion.Body style={{ padding: 0 }}>
                {compIndex === "overall" && <InnerDetailTable horsehistory={horsehistory} handleShowRace={handleShowRace} handleShowJockey={handleShowJockey} handleShows={handleShows} distanceLabel={distanceLabel} t={t} cookiedata={cookiedata} />}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {/* 2. YEARLY STATS MAPPING */}
          {horsemodalstats?.data?.map((item, i) => (
            <Accordion className="new-horse-stats-accordion-wrapper" key={i} activeKey={compIndex === i ? "0" : ""}>
              <Accordion.Item eventKey="0" className="new-horse-acc-item">
                <Accordion.Header className="new-horse-acc-header-custom" onClick={() => handleTrainerRecord(item.Years, i)}>
                  <div className="new-horse-acc-header-grid">
                    <div className="new-horse-bold-text">{item?.Years}</div>
                    <div>{item.Detail?.Runs}</div><div>{item.Detail?.wins}</div>
                    <div>{item.Detail?.second}</div><div>{item.Detail?.third}</div>
                    <div>{item.Detail?.fourth}</div><div>{item.Detail?.fifth}</div>
                    <div className="new-horse-bold-text">{t("AED")} {Number(item.Detail?.earning || 0).toLocaleString()}</div>
                    <div>{Number(item.Detail?.winspercentage || 0).toFixed(2)}</div>
                    <div>{Number(item.Detail?.placespercentage || 0).toFixed(2)}</div>
                    <div></div>
                    <div style={{ textAlign: 'right' }}>
                      {compIndex === i ? <MdKeyboardArrowDown className="new-horse-acc-arrow-icon" /> : <MdKeyboardArrowRight className="new-horse-acc-arrow-icon" />}
                    </div>
                  </div>
                </Accordion.Header>
                <Accordion.Body style={{ padding: 0 }}>
                  {compIndex === i && <InnerDetailTable horsehistory={yearHistory[item.Years]} handleShowRace={handleShowRace} handleShowJockey={handleShowJockey} handleShows={handleShows} distanceLabel={distanceLabel} t={t} cookiedata={cookiedata} />}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ))}
        </div>

        {/* Modals Preserved */}
        <Modal show={shows} onHide={handleCloses} size="lg" centered><Modal.Body><VideoFrame data={modaldatas} /></Modal.Body></Modal>
        <Modal show={ShowJockey} onHide={handleJockeyCloses} size="lg" centered><Modal.Body><JockeyDetail data={modaldatasJockey} /></Modal.Body></Modal>
        <Modal show={showRace} onHide={handleCloseRace} size="lg" centered><Modal.Body><RaceModal id={modaldataRace} /></Modal.Body></Modal>
      </div>
    </div>
  );
};

// --- HELPER COMPONENT FOR 15-COLUMN INNER TABLE ---
const InnerDetailTable = ({ horsehistory, handleShowRace, handleShowJockey, handleShows, distanceLabel, t, cookiedata }) => {
  const displayList = useMemo(() => {
    if (!horsehistory || !Array.isArray(horsehistory)) return [];
    return [...horsehistory].sort((a, b) => {
      const aDate = new Date(a?.RaceResultData?.StartTime || a?.RaceResultData?.Day || 0).getTime();
      const bDate = new Date(b?.RaceResultData?.StartTime || b?.RaceResultData?.Day || 0).getTime();
      return bDate - aDate;
    });
  }, [horsehistory]);

  if (!horsehistory) return <div className="text-center py-4"><PleaseWait /></div>;
  if (displayList.length === 0) return <div className="text-center py-4">{t("No History Yet")}</div>;

  return (
    <ScrollContainer>
      <div className="new-horse-inner-grid-table">
        <div className="new-horse-inner-grid-header">
          <div>{t("Date")}</div><div>{t("Crs")}</div><div>{t("Dist")}</div><div>{t("RT")}</div><div>{t("Time")}</div><div>{t("Jockey")}</div><div>{t("Wgt")}</div><div>{t("FP")}</div><div>{t("Len")}</div><div>{t("RN")}</div><div>{t("BtBy")}</div><div>{t("Kgs")}</div><div>{t("Draw")}</div><div>{t("OR")}</div><div></div>
        </div>
        <div className="new-horse-inner-grid-body">
          {displayList.map((item, idx) => {
            const groundName = item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameEn;
            const groundAr = item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameAr;
            return (
              <div key={idx} className={`new-horse-inner-card-row ${groundName === "Dirt" ? 'row-dirt' : groundName === "Turf" ? 'row-turf' : 'row-default'}`}>
                <div onClick={() => handleShowRace(item.RaceID)} className="new-horse-link-text"><Moment format="DD/MM/YYYY">{item.RaceResultData?.StartTime || item.RaceResultData?.Day}</Moment></div>
                <div>{cookiedata === "en" ? item.RaceResultData?.RaceCourseData?.AbbrevEn : item.RaceResultData?.RaceCourseData?.AbbrevAr} ({cookiedata === "en" ? groundName?.charAt(0) : groundAr?.charAt(0)})</div>
                <div>{item.RaceResultData?.TrackLengthData?.TrackLength}</div>
                <div>{cookiedata === "en" ? toTitleCase(truncateRaceType(item.RaceResultData?.RaceTypeModelData?.NameEn)) : item.RaceResultData?.RaceTypeModelData?.NameAr}</div>
                <div>{item.RaceTime || item.RaceResultData?.RaceTime || "-"}</div>
                <div onClick={() => handleShowJockey(item.JockeyOnRaceDataResult?._id)} className="new-horse-link-text">{cookiedata === "en" ? toTitleCase(item.JockeyOnRaceDataResult?.ShortNameEn) : item.JockeyOnRaceDataResult?.ShortNameAr}</div>
                <div>{item.HorseIDData ? item.HorseIDData.BeatenByJockeyWeight : 0}</div>
                <div>{cookiedata === "en" ? toTitleCase(item.FinalPositionDataHorse?.NameEn) : item.FinalPositionDataHorse?.NameAr}</div>
                <div>{distanceLabel(item.Distance, item.FinalPositionDataHorse?.Rank)}</div>
                <div>{item.RaceResultData?.Runners}</div>
                <div>{item.BeatenByData ? toTitleCase(cookiedata === "en" ? item.BeatenByData?.NameEn : item.BeatenByData?.NameAr) : toTitleCase(cookiedata === "en" ? item.HorseIDData?.HorseBeatenByEnglishName : item.HorseIDData?.HorseBeatenByArabicName)}</div>
                <div>{item.BeatenByData?.WinningHorseJockeyWeight ? Number(item.BeatenByData.WinningHorseJockeyWeight).toFixed(1) : 0}</div>
                <div>{item.RaceResultData?.Draw || "-"}</div>
                <div>{item.Rating || 0}</div>
                <div className="my-new-play-btn" onClick={() => handleShows(item.VideoLink)}><IoMdPlay /></div>
              </div>
            );
          })}
        </div>
      </div>
    </ScrollContainer>
  );
};

export default Stats;